<template>
  <div class="cmsdetail">
    <div class="container_wrap">
      <!--      <el-breadcrumb separator-class="el-icon-arrow-right" class="breadcrumb">-->
      <!--        <el-breadcrumb-item v-for="(item, index) in breadData" :key="index"-->
      <!--          ><a>{{ item.name }}</a></el-breadcrumb-item-->
      <!--        >-->
      <!--        <el-breadcrumb-item>内容详情</el-breadcrumb-item>-->
      <!--      </el-breadcrumb>-->
      <div class="left_and_right_container">
        <div class="container_left">
          <div class="container_left_title">
            {{ row.title }}
          </div>
          <div class="container_left_tips">
            <div class="tips_left">
              <div class="tips_left_tag" v-if="breadData.name">{{ breadData.name }}</div>
              <div class="operations_common operations_date">
                <div class="operations_common_icon"></div>
                <div class="operations_common_num">
                  {{ row.update_time | yearForm }}年{{
                    row.update_time | monthForm
                  }}月{{ row.update_time | dayForm }}日
                </div>
              </div>
              <div class="operations_common operations_hotnum">
                <div class="operations_common_icon"></div>
                <div class="operations_common_num">
                  {{ row.views_count }}
                </div>
              </div>
            </div>
            <div class="tips_right">
              <!--              <vshare :vshareConfig="vshareConfig"></vshare>-->
              <!-- <share :config="{url: url,title: share_data.title, description: share_data.desc, image: '', sites: ['qzone', 'qq', 'weibo','wechat', 'douban']}"></share> -->
              <!--              <div class="social-share" :data-sites="['qzone', 'qq', 'weibo','wechat', 'douban']"></div>-->
            </div>
          </div>

          <div class="container_left_content">
            <div class="fdown" v-if="row.files.length>0">
              文件下载
              <p v-for="(file,key) in row.files" :key="key" @click="download(file)">{{ file.name }}</p>
            </div>
            <!-- ****************************↑富文本区域*****************  v-html=""-->
            <div class="container_left_text" v-html="row.content" style=""></div>
          </div>
        </div>
        <RightNav :list="list"></RightNav>
      </div>
    </div>

  </div>
</template>
<script>
// import "http://static.bshare.cn/b/buttonLite.js#style=-1&amp;uuid=&amp;pophcol=1&amp;lang=zh";
// import "http://static.bshare.cn/b/bshareC0.js";
import NewsListItem from "@/components/mainindex/NewsListItem";
import RightNav from "@/components/mainindex/RightNav";
import Vue from 'vue'
import Share from 'vue-social-share'

Vue.use(Share)
export default {
  name: "CmsDetail",
  data() {
    return {
      isShowShare: false,
      recommendpics: [],
      recommendnews: [],
      url: '',
      row: {
        id: 0,
        title: '2020年全国啦啦操公开赛日程安排及通知公告',
        content: '',
        files: ''
      },
      share_data: {},
      list: [],
      breadData: [{name: ""}, {name: ""}], //面包屑的内容
      vshareConfig: {
        shareList: ['weixin', 'copy', 'tsina', 'douban', "qzone", "more"],
        common: {
          //此处放置通用设置
          bdText: "",
          bdDesc: "",
          bdUrl: "",
          bdPic: "",
        },
        share: [
          {
            //此处放置分享按钮设置
            bdSize: 20
          },
        ],
        slide: [
          //此处放置浮窗分享设置
          {bdTop: -1000}
        ],
        image: [
          //此处放置图片分享设置
        ],
        selectShare: [
          //此处放置划词分享设置
        ],
      },
    };
  },
  beforeCreate() {
    window._bd_share_main = "";
  },
  created() {
    // window.location.reload()
    this.url = window.location.href
  },
  mounted() {
    window.scrollTo(0, 0);

    if(window.isWeixin()){
      location.href='https://h5.ccachina.net/cca-h5/dist/news-detail?id='+this.$route.query.id
      retrun ;
    }

    this.getDetail(this.$route.query.id);
    // this.$nextTick(()=>{
    //   this.dyCreateScript('http://static.bshare.cn/b/buttonLite.js#style=-1&amp;uuid=&amp;pophcol=1&amp;lang=zh')
    //   this.dyCreateScript('http://static.bshare.cn/b/bshareC0.js')
    // })
    console.log("window.location.href", window.location.href)
    this.geRecommendlist();
  },
  components: {
    NewsListItem, RightNav
  },
  methods: {
    geRecommendlist() {
      const that = this;
      that.$api.get(
          "/api/cms/recommendList",
          {
            cate_id: 12,
          },
          (res) => {
            this.list = res.data;
          }
      );
      // that.$api.get(
      //   "/api/cms/recommendList",
      //   {
      //     cate_ids: 86,
      //   },
      //   (res) => {
      //     this.recommendpics = res.data;
      //   }
      // );
    },
    dyCreateScript(url) {
      // 创建script标签，执行script内容
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src = url;
      document.getElementsByTagName("head")[0].appendChild(script);
    },
    //获取面包屑的内容
    getStoreBread(cate_id) {
      var that = this;
      that.$api.get(
          "/api/cms/cateDetail",
          {
            cate_id: cate_id,
          },
          (res) => {
            // this.$message.success("发送成功");
            that.breadData = res.data;
          },
          (r) => {
            that.$message.error(r.msg);
          }
      );
    },

    download(file) {
      // 判断如果是PDF文件 直接在页面中打开 vue-pdf??

      appEvent({
        name: 'downloadFile',
        query: {
          name: file.name,
          url: file.url,
        }
      });
    },

    searchFun() {
      this.$message({type: "success", message: "search"});
    },
    getDetail(id) {
      var that = this;
      that.$api.get(
          "/api/cms/detail",
          {
            id: id,
          },
          (res) => {
            // this.$message.success("发送成功");
            // console.log("resres.....",res)
            that.row = res.data.data;
            that.share_data = res.data.share_data

            console.log("share_data.url", that.share_data.url)
            that.vshareConfig.common.bdText = res.data.share_data.title
            that.vshareConfig.common.bdDesc = res.data.share_data.desc
            that.vshareConfig.common.bdUrl = res.data.share_data.url
            that.vshareConfig.common.bdPic = res.data.share_data.pic_url
            // console.log(that.vshareConfig.common)
            //通知公告
            that.getStoreBread(that.row.cate_ids[0]);
            that.isShowShare = true

            document.title = res.data.data && res.data.data.title ? res.data.data.title : ''
          },
          (r) => {
            that.$message.error(r.msg);
          }
      );
    },
  },
  watch: {
    // $route: {
    //   handler() {
    //     if(this.$route.name=="CmsDetail"){
    //       this.getDetail(this.$route.query.id);
    //     }
    //   },
    //   deep: true,
    // },
  },
};
</script>
<style scoped lang="scss">
.cmsdetail {
  width: 100%;
  background: #f4faff;
  height: 100%;
  overflow: hidden;
}

.container_wrap {
  width: 1240px;
  margin: 0 auto;
}

.fdown {
  background-color: #f8f8f8;
  border-radius: 10px;
  padding: 10px;
  margin-top: 10px;
}

.fdown p {
  color: #2b7aff;
  text-decoration: blink;
  font-size: 16px;
  margin-top: 20px;
  cursor: pointer;
}


.breadcrumb {
  margin-top: 21px;
  margin-left: 23px;
  margin: 21px 0 20px 23px;
}

.left_and_right_container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 40px;

  .container_left {
    width: 871px;
    box-sizing: border-box;
    margin-left: 23px;
    margin-top: 38px;
    margin-bottom: 30px;


    .container_left_title {
      margin-left: 7px;
      width: 801px;
      font-size: 30px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
      line-height: 42px;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }

    .container_left_tips {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
      margin-top: 16px;

      .tips_left {
        display: flex;
        flex-direction: row;

        .tips_left_tag {
          //width: 70px;
          padding: 0 10px;
          height: 22px;
          background: rgba(50, 197, 255, 0.7);
          border-radius: 10px 10px 10px 0px;
          text-align: center;
          line-height: 22px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #ffffff;
        }

        .operations_common {
          display: flex;
          flex-direction: row;
          height: 20px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 20px;

          .operations_common_icon {
            display: inline-block;
            margin-right: 4px;
            margin-top: 2px;
            width: 19px;
            height: 16px;
            background: url("~@/assets/images/mainindex/icon-news-list-time@2x.png") no-repeat;
            background-size: 100% 100%;
          }
        }

        .operations_date {
          margin-left: 25px;
        }

        .operations_hotnum {
          margin-left: 29px;

          .operations_common_icon {
            width: 13px;
            height: 16px;
            background: url("~@/assets/images/mainindex/icon-news-list-hot@2x.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }

    .container_left_content {
      margin-top: 24px;
      background: #fff;
      padding: 20px;
      border-radius: 10px;
    }

    .container_left_text {
      overflow: hidden;
      width: 100%;
    }
  }

  .container_right {
    width: 306px;

    .container_right_hotrecommend {
      width: 306px;
      height: 450px;
      background: #fff4ed;
      border-radius: 17px;
      padding-left: 13px;
      padding-right: 11px;
      box-sizing: border-box;

      .container_right_hotrecommend_icon {
        width: 125px;
        height: 55px;
        line-height: 55px;
        background: url("~@/assets/images/mainindex/icon-news-list-recommend@2x.png") no-repeat;
        background-size: 100% 100%;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #000000;
        padding-left: 30px;
        box-sizing: border-box;
      }

      .container_right_hotrecommend_img {
        width: 282px;
        height: 121px;
        // background: url("~@/assets/images/mainindex/pic-news-recommend@2x.png")
        //   no-repeat center center;
        // background-size: 100%;
        img {
          width: 100%;
          height: 100%;
        }
      }

      .container_right_hotrecommend_font {
        width: 267px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 17px;
        margin-top: 23px;

        ul li {
          list-style: disc;
          margin-left: 14px;
          margin-top: 15px;

          &::marker {
            color: #87c5f5;
          }

          &:hover {
            font-weight: bolder;
            cursor: pointer;
          }
        }
      }
    }

    .container_right_doublecode {
      width: 302px;
      height: 116px;
      background: #f8f8f8;
      border-radius: 20px;
      margin-top: 48px;
      padding: 19px 0 19px 11px;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      margin-bottom: 20px;

      .container_right_doublecode_img {
        width: 78px;
        height: 78px;
        background: url("~@/assets/images/mainindex/icon-erweima@2x.png") no-repeat center center;
        background-size: 100% 100%;
      }

      .container_right_doublecode_font {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
        line-height: 20px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        margin-top: 5px;
        margin-left: 8px;
        box-sizing: border-box;

        .container_right_doublecode_font_down {
          font-weight: bolder;
        }
      }
    }
  }
}
</style>
<style>
.container_left_text img {
  max-width: 100%;
  height: auto;
}
</style>



// WEBPACK FOOTER //
// CmsDetail.vue?97188910